/* global veriables */
var GLOBAL_MRK_MENU = null;
var GLOBAL_ELEMENTS = null;
var GLOBAL_MESSAGES = null;
var GLOBAL_MENUE_XML = null;
var currentMenueActive = null;
var currentHamburgerMenueActive = null;
var currentPersonalMenueActive = null;
var initStrings = false;
var plusMenuUl;
var hamburgerExist = false;
var systemLanguage = null;
var lastMenuItemClicked = "";
var lastMainMenuItemClicked = "";
var windowWidth = 0;
var windowHight = 0;
var timer;

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/* global callback functions, wrappers that change scope to GLOBAL_MRK_MENU object context */
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function feedrefesh(e)
{
	getfeed(false);
}
function feedmore(e)
{
	getfeed(true);
}
var lastXmlData;
var showfeed = true;
var rebuildhomepage = false;

function feedresize(e)
{
	e.stopPropagation();
	e.preventDefault();
	showfeed = !showfeed;
	rebuildhomepage = true;
	create_homepage_menu(0,lastXmlData);
}

var lastEvent = null;
function global_callback_change(menuType, ex, xmlData, isPersonalMain) {
	if (GLOBAL_MRK_MENU != null)
		GLOBAL_MRK_MENU.menuChangeCallback(menuType, ex, xmlData, isPersonalMain);
	
	$(".merk_menu,#personal_menu,.firstItem,.lastItem").mousedown(function (event) {
			custom_menue_click(event);
		});
		
		$('[class^=merk_menu_item_]').mousedown(function(event) {
			custom_menue_click(event);
		});

		
	   
		$(window).resize(function(){
			if (GLOBAL_MENUE_XML != null && (windowWidth != window.innerWidth || windowHight!=window.innerHeight)) {
				windowWidth = window.innerWidth;
				windowHight = window.innerHeight;
				$('#mainMenu').find('li').empty();
				GLOBAL_MRK_MENU.headFrame = GLOBAL_MRK_MENU.currentFrame = new MrkMenuFrame(0, null, GLOBAL_MENUE_XML, menuType);
			//	GLOBAL_MRK_MENU.headFrame.draw();

			}
		});

		
		if (!initStrings) {
			//set placeholder values
			$(".searchInput").attr("placeholder", get_message_string(94));
			$("#hideEsearchBtn").text(get_message_string(392));
			$('#btnAdvanced').text(get_message_string(54));
			$('a.btnOpenedWindows').attr('title', get_message_string(1203));
			$('#help').attr('title', get_message_string(1101));
			$('#personal_menu').attr('title', get_message_string(1009));
			$('.btnHamburger').attr('title', get_message_string(194));
			$('a.btnMenu').attr('title', get_message_string(395));
			$('#personalization-center').attr('title', get_message_string(1653));
			
			initStrings = true;
		}
		
		$('.scrollMenue.lastMenu').bind('mousewheel', function(e){
			e.stopPropagation();
			if(e === lastEvent)
				return;
			lastEvent = e;
			var $ulParent= $(e.target).parent("ul").length ? $(e.target).parent("ul") : $(e.target).parent().parent("ul");
			//if(!$ulParent.hasClass('lastMenu') || !$ulParent.hasClass('scrollMenue'))
			if (!$ulParent.hasClass('scrollMenue'))
				return;
			if(e.originalEvent.deltaY < 0) 
				clickScrollMenueUp($ulParent);
			else
				clickScrollMenueDown($ulParent);
		});

		if(isPersonalMain && $('#btnFavorite').is(':visible') ){
			$('#btnFavorite').hide();
		}
}

function global_callback_active(active) {
	if (GLOBAL_MRK_MENU != null)
		GLOBAL_MRK_MENU.activeChangeCallback(active);
}

function global_callback_clear(type, ex) {
	if (GLOBAL_MRK_MENU != null)
		GLOBAL_MRK_MENU.activeChangeCallback(type, ex);
}

function global_callback_date_range(passedObject, dateRange)
{
	passedObject.activatePriform("DATES", dateRange, true, null, "_opener")
}
function global_click(ex, menuFrameId, clientX, clientY) {

	//$('.personalMenu').addClass("displayNone");
	if (GLOBAL_MRK_MENU != null) {
		GLOBAL_MRK_MENU.click(ex, menuFrameId,clientX,clientY);

		// Fix for bug with many opened top menus
		var $topMenuItems = $("li.menue_li:not(.active)").not(".add").children("ul");
		if ($topMenuItems) {

			$topMenuItems.remove('ul');
		}   
	}


}

function global__right_click(ex, menuFrameId) {
	if (GLOBAL_MRK_MENU != null)
		GLOBAL_MRK_MENU.click(ex, menuFrameId);
}

function general_click_to_close_menu() {

	$('body').on('click', function (e) {
		//did not click a merk_menu
		if (($(e.target).attr('class') != null) && !$(e.target).attr('class').includes('portletBigDots')) {
			$(".portletDropdownContentWide").removeClass("portletShow");
			$(".portletDropdownContent").removeClass("portletShow");
			$(".portletDropdownContainer").removeClass("portletShow");
		}

		$('.helpContainer').find('.dropMenu').remove();
		
		var isIgnoreClickOutSide = $(e.target).hasClass("ignoreMenuClickoutside") || $(e.target).closest(".ignoreMenuClickoutside").length > 0;
		if (!$(e.target).hasClass('merk_menu_item_M') && !$(e.target).hasClass('gwt-PushButton') && !$(e.target).hasClass('merk_menu') && !$(e.target).parent().hasClass('btnFavorite')
			&& !$(e.target).hasClass("menuItemTextStyle_rtl") && !$(e.target).hasClass('btnHamburger') && $(e.target).parents('#mainMenu').length === 0
			&& ($(e.target).parents('.toolBar').length === 0 || $(e.target).attr("data-type") != "Menu") && !isIgnoreClickOutSide)  {
		
			//if lastMenuItemClicked is an item we want to save the menus so we can return to the same position on the same menu clicked again
			if (lastMenuItemClicked == "M" || lastMenuItemClicked == "P" || lastMenuItemClicked == "R" || lastMenuItemClicked == "F" ||lastMenuItemClicked == "")
				$('ul:not(.add .dropMenu)', '#mainMenu').addClass("displayNone");
			$('.personalMenu').addClass("displayNone");
			$('.add .dropMenu').addClass("displayNone");
			$('.hamburgerMenu').find('.toolBar').remove();
			// $('.helpContainer').find('.dropMenu').remove();
			
			if(e.target.id == "searchbottomHeader")
			{
				hide_search_popup("X");
			}
		}

        if($(e.target).hasClass("merk_menu_item_F")){
            var ulParent=$(e.target).closest("ul");
            if(ulParent.hasClass("dropMenu lastMenu")){
                ulParent.find("li").removeClass("active");
                $(e.target).parent("li").addClass("active");
            }
        }

		if ($(e.target).hasClass('merk_menu')) {
			$('.personalMenu').addClass("displayNone");
			$('.hamburgerMenu').find('.toolBar').remove();

			// Resolving issue with using arrows in menu after hidding it
			if ($('.active').find('ul').hasClass('displayNone')) {
				$('.active').find('a').blur();
			}   
		}
		else if ($(e.target).attr('id') == "personal_menu") {
			$('ul:not(.add .dropMenu)', '#mainMenu').addClass("displayNone");
			$('.hamburgerMenu').find('.toolBar').remove();
		} 
		
		/*else if ($(e.target).hasClass("gwt-PushButton LastDialogButton gwt-PushButton-focused gwt-PushButton-up") 
			|| $(e.target).hasClass("gwt-PushButton MiddleDialogButton gwt-PushButton-focused gwt-PushButton-up")) {
			focus_menu_callback(0);
		}*/
		
		if (!$(e.target).hasClass('advancedQueryBtn')) {
			$('.advancedQueryList').addClass('displayNone');
		}
	});
}

function menue_key_pressed(event) {
   
	event.stopPropagation();
	event.preventDefault();
	if (event.which == 37) {
		var clickFunc = event.target.parent.first.attributes.onclick.value;
		event.stopPropagation();
		event.preventDefault();
		clickFunc = clickFunc.replace('global_click(', '');
		clickFunc = clickFunc.replace(')', '');
		var values = clickFunc.split(',');
		global_click(values[0], values[1]);
	}
	  

}

function set_sliding_menu() {
	$('#mainMenu').on('click', '.merk_menu', function () {
		var curLi = $(this).next('ul');
		if ($(this).is(":visible")) {
			curLi.remove();
		}
		else {
		}
	});
}

//Catch right click event and call the global clock with x,y
function custom_menue_click(event) {
	event.stopPropagation();
	event.preventDefault();
	if (event.which == 3) {
		var clickFunc = event.currentTarget.attributes.onclick.value;
		event.stopPropagation();
		event.preventDefault();
		if (clickFunc.indexOf("personal_item_menue_click") == -1) {
			clickFunc = clickFunc.replace('global_click(', '');
			clickFunc = clickFunc.replace(')', '');
			var values = clickFunc.split(',');
			global_click(values[0], values[1], event.clientX, event.clientY);
		} else {

			clickFunc = clickFunc.replace('personal_item_menue_click(', '');
			clickFunc = clickFunc.replace('toolbar_item_menue_click(', '');
			clickFunc = clickFunc.replace(')', '');
			clickFunc = clickFunc.replace(/'/g, "");


			var values = clickFunc.split(',');

			menuRightClick(Number(values[0]), Number(values[1]), Number(values[2]), values[3], values[4], values[5], event.clientX, event.clientY);

		}
	}
}


// lang (int)
//1: Hebrew (RTL)
//29: Arabic (RTL)
//Other values LTR languages (I can send you a list if you need it)
function global_lang(lang) {
	systemLanguage = lang;

	if (systemLanguage == 1 || systemLanguage == 29) {
		$('html').attr('dir', 'rtl');
	} 

	// Priority API that return date format depending on system language
	var dateFrmt = getDtFormat(0).toLowerCase();

	// Set Custom filter format to the current Priority system language
	$("#from").datepicker("option", "dateFormat", dateFrmt);
	$("#to").datepicker("option", "dateFormat", dateFrmt);
}

function trial_days_remaining(days_remaining)
{
	$(".timeRemainingInTrail").text(days_remaining);
}

//username (string)
function global_username(username) {
	$(".loginName").text(username);
	$(".wrapper").removeClass("displayNone");
	$(".btnAdvanced").addClass("displayNone");
	$(".topMenuPanelStyle").addClass("displayNone");
	$("body").addClass("body-overflow");

	

}

//name: name of company (string)
//color: Color of company (string) (In format RGB: for example #26b3b6)
function global_menu_company_change(name, color, isHomepage) {

	$("#companyName").text(name);
	$("#companyName").css("background", color);
	$("#companyName").css("cursor", "pointer");
	
	if (!isHomepage) {
		return;
	}
	
	//show home page on login and hide search from the header
	$(".wrapper").removeClass("displayNone");
	$(".btnAdvanced").addClass("displayNone");
	$("body").addClass("body-overflow");

	//hide hamburger menu on login
	$(".topMenuPanelStyle").addClass("displayNone");
}

//name: name of company (string)
//color: Color of company (string) (In format RGB: for example #26b3b6)
function global_form_company_change(name, color) {

}

/* global init function that crates menu object and connects callback to GWT */
function global_init() {
   if (GLOBAL_MRK_MENU === null)
	GLOBAL_MRK_MENU = new MrkMenu();

	general_click_to_close_menu();
	SetAPICallbacks(callbacks);
	toggleMenu();
	helpBtn();
	logoClick();
	hideEsearchBtnClick();
	$('#hamburgerMenu').on('click keydown', function (e) {
		e.stopPropagation();
		e.preventDefault();
		//$(this).find('ul').children('li:first-child').addClass('active');
		//$(this).find('ul').children('li:first-child').addClass('active').children('a').focus();
		hamburgerMenu_key_event(e);
		if ($(e.target).closest('.btnHamburger').length > 0) {
			if (hamburgerExist) {
				$("#hamburgerMenu").find("ul.toolBar").remove();
				return;
			}
		}
	});

	$('#btnAdvanced').on('click', function() {
		hide_search_popup();
	});
	inputTextClickEventListener();
}

function logoClick() {
	$('#logo').on('click', function() {
		minimizeAll();
		hide_search_popup();
		$('.btnAdvanced').addClass('displayNone');
	});
}

function inputTextClickEventListener() {
	$('body input[type="text"]').on('click ,focus', function (e) {
		$('.personalMenu').addClass("displayNone");
		$('.add .dropMenu,.dropMenu').addClass("displayNone");
		$('.hamburgerMenu').find('.toolBar').remove();
		$('.helpContainer').find('ul').remove();
	});

}

function clickScrollMenueUp ($ulParent) {
	var firstItemShow = $ulParent.children().not(".hideItem").not(".firstItem").first();
	showScrollItemUp(firstItemShow.prev());
	if($ulParent.children('li').children('ul').length) {
		$ulParent.children('li').children('ul').remove();
	}
}

function clickScrollMenueDown ($ulParent) {
	var lastItemShow = $ulParent.children().not(".hideItem").not(".lastItem").last();
	showScrollItemDown(lastItemShow.next());
	if($ulParent.children('li').children('ul').length) {
		$ulParent.children('li').children('ul').remove();
	}
}

function scrollClick (currentScrollMenue) {
	
	if(currentScrollMenue.children('.lastItem').prev().hasClass('hideItem'))
	{
		if (currentScrollMenue.children('.lastItem').css('cursor') != "pointer") 
		{
			currentScrollMenue.children('.lastItem').on('click', function (e) {
				clickScrollMenueDown($(e.target).parent("ul"));
			});
			currentScrollMenue.children(".lastItem").css('cursor', 'pointer');
		}
	}
	else 
	{
		if (currentScrollMenue.children('.lastItem').css('cursor') != "no-drop")
		{
			currentScrollMenue.children(".lastItem").off("click");
			currentScrollMenue.children(".lastItem").css('cursor', 'no-drop');
		}
	}
	
	if(currentScrollMenue.children('.firstItem').next().hasClass('hideItem')) 
	{
		if (currentScrollMenue.children('.firstItem').css('cursor') != "pointer") 
		{
			currentScrollMenue.children('.firstItem').on('click', function (e) {
				clickScrollMenueUp($(e.target).parent("ul"));
			});
			currentScrollMenue.children(".firstItem").css('cursor', 'pointer');
		}
	}
	else
	{
		if(currentScrollMenue.children(".firstItem").css('cursor') != 'no-drop')
		{
			currentScrollMenue.children(".firstItem").off("click");
			currentScrollMenue.children(".firstItem").css('cursor', 'no-drop');
		}
	}
	
}

function helpBtn() {
	$('.helpContainer').on('click', function (e) {
		menuClickNew(5, 0, 140, "", "", "");
		
		if (($('.helpContainer').find('ul').length > 1)) {
			$('.helpContainer').find('ul').remove();
			e.preventDefault();
			e.stopPropagation();
		}

		$('.helpContainer .dropMenu li a').on('click', function (ev) {
			if ($(ev.target).attr("data-type") == "Menu") {
				ev.preventDefault();
				ev.stopPropagation();
				return;
			}
			if ($('.helpContainer').find('ul').length > 0) {
				$('.helpContainer').find('ul').remove();
				ev.preventDefault();
				ev.stopPropagation();
			}
		});
		$('.personalMenu').addClass("displayNone");
		$('.menue_li .dropMenu').addClass("displayNone");
		if ($('.hamburgerMenu').find('.toolBar').length > 0) {
			$('.hamburgerMenu').find('.toolBar').remove();
			menuClickNew(5, 0, 140, "", "", "");
		}
		$(".advancedQueryList").addClass("displayNone");
		$('.helpContainer').find('ul').first().children().removeClass('active');
		$('.helpContainer').find('ul').first().children('li:first-child').addClass('active');
		e.preventDefault();
		e.stopPropagation();

	  
	});

	$('.helpContainer').on('keydown', function(e) {
		helpNavOnKeyPress(e);
	});
}

function helpNavOnKeyPress(e) {

	if (e.keyCode == 37 || e.keyCode == 13) {
		if (systemLanguage == 1) {
			helpLeftArrowClick(e.target);
			return false;
		} else {
			helpRightArrowClick(e.target);
			return false;
		}
	} else if (e.keyCode == 38) {
		helpUpArrowClick(e.target);
		return false;
	} else if (e.keyCode == 39) {
		if (systemLanguage == 1) {
			helpRightArrowClick(e.target);
			return false;
		} else {
			helpLeftArrowClick(e.target);
			return false;
		}
	} else if (e.keyCode == 40) {
		helpDownArrowClick(e.target);
		return false;
	} else if (e.keyCode == 27) {
		$('.helpContainer').find('ul').remove();
		focusEnt();
		return false;
	}
	e.preventDefault();
	e.stopPropagation();
	return false;
}

function helpDownArrowClick(e) {
	var current = $(e).closest('.helpContainer').find('ul').last().find('li.active');
	if (current.length > 0) {
		if ($(current).next('li').length > 0) {
			current = $(current).next('li');
			current.siblings().removeClass('active');
			current.addClass('active');
		}
		else {
			current = current.closest('ul').children('li:first-child');
			if (current.length > 0) {
				current.siblings().removeClass('active');
				current.addClass('active');
			}
		}
	} 
}

function helpUpArrowClick(e) {
	var current = $(e).closest('.helpContainer').find('ul').last().find('li.active');
	if (current.length > 0) {
		if ($(current).prev('li').length > 0) {
			current = $(current).prev('li');
			current.siblings().removeClass('active');
			current.addClass('active');
		}
		else {
			current = current.closest('ul').children('li:last-child');
			if (current.length > 0) {
				current.siblings().removeClass('active');
				current.addClass('active');
			}
		}
	}
}

function helpLeftArrowClick(e) {
	var current = $(e).closest('.helpContainer').find('ul').last().find('li.active');
	if (current.length > 0) {
		current.find('a').click();
		if ($('.dropMenu.lastMenuHelp').length > 0) {
			current = $('.dropMenu.lastMenuHelp').children('li').first();
			current.addClass('active');
		}
	}
}

function helpRightArrowClick(e) {
	var current = $(e).closest('.helpContainer').find('ul').last().find('li.active');
	if (current.length > 0) {
		current.closest('ul').remove();
	} else {
		$(e).click();
	}
}

function toggleMenu() {
	$('#btnMenu').click(function() {
		$('#menuHeader').toggleClass("active");
		$('body').toggleClass("no-bottom-header");
		$('#menuHeader').promise().done(function () {
		/* set menuHeaderHeight according to the height given to the topHeader component in styles.css */
		var topMenuHeight = 38;
			var menuHeaderheight = $('#menuHeader').hasClass('active') ? topMenuHeight : $('#menuHeader').height();
			resizePage(menuHeaderheight);
			$('#esearchPopup').animate({top: menuHeaderheight});

		});
	});
}

function init_params(params)
{
	global_username(params.UserName);
	GLOBAL_MESSAGES = params.Messages;
}

function get_message_string(id)
{
	var stringValue = '';
	var $x = GLOBAL_MESSAGES;
	xmlDoc = $.parseXML($x), $xml = $(xmlDoc);
	 $(xmlDoc).find('ExtMessage').each(function () {
	   if($(this).find('num').text() == id){
		stringValue= $(this).find('message').text();
	   }
	});
	return stringValue;
}
var homepageUpdateInProgress = false;

async function refreshHomePageData() {
	if (homepageUpdateInProgress) {
		homepageUpdateInProgress = true;
		return;
	}

	try {
		const isNewHomepage = window['common'] && window['common'].getIsNewHomepage && window['common'].getIsNewHomepage()
		if (isNewHomepage) {
			const newHomepageHandler = window['homepage']?.getHomepageData || function () {};
			return await newHomepageHandler(false);
		} else {
			return RefreshHomePage();
		}
	} finally {
		homepageUpdateInProgress = false;
	}
}

async function home_page_display_change(display)
{
	if (display)
	{
		refreshAllinHomePage();
		timer = setInterval(function(){  refreshAllinHomePage(); }, 600000);
		show_home_page();
		rebuildhomepage = true;
		await refreshHomePageData();
	}
	else
	{
		clearInterval(timer);
		hide_home_page("F");
		hide_menu("F");
	}
}

function refreshAllinHomePage(){
	if (window.navigator && !window.navigator.onLine)
		return;
		
	var completeRecentUpdates = GetRecentUpdates();
	if(completeRecentUpdates != "-1"){
		var completeHomePage = refreshHomePageData();
		if(completeHomePage == "-1"){
			setTimeout(function(){
				refreshHomePageData();
			}, 1000);
		}
	}
	else{
		setTimeout(function(){
			completeRecentUpdates = GetRecentUpdates();
			if(completeRecentUpdates != "-1"){
				var completeHomePage = refreshHomePageData();
				if(completeHomePage == "-1"){
					setTimeout(function(){
						refreshHomePageData();
					}, 1000);
				}
			}
		}, 600000);
	}
}

function open_ent_change(numberOfOpenWin)
{
	$('.openedWindowsNumber').text(numberOfOpenWin);
}

var esearch_ac_callback = function(data) 
	{
	  var result = [];
	  var myjson = JSON.parse(data);
	  data = myjson.response.docs;
	  for (var i = 0; i < data.length; i++) {
		var d = data[i];
		var name = d.ac_text1 && d.ac_text1.indexOf(this.term) != -1 ? d.ac_text1 : d.name;
		var label = "<b>" + name + "</b>&nbsp;" + d.type;
		/* The label property is displayed in the suggestion menu. The value will be inserted 
		   into the input element when a user selects an item.  */
		result.push({label: label, value: name});
	  }
	  $("#esquery").data("acdata", data);
	  window.ac_response(result);
	};

var esearch_find_callback = function(data)
	{
		Manager.response = JSON.parse(data);
		for (var widgetId in Manager.widgets) 
		  Manager.widgets[widgetId].afterRequest();
	  
		$('#esearchPopup').removeClass("displayNone");
	}

function focus_menu_callback(menuType) {
	if (menuType == 1) {
		hide_menu("X");
		personal_menu_click();
	}
	if (menuType == 0) {
	 show_last_active_main_menue();
	}
	if (menuType == 5) {
		$('.btnHamburger.btnDropDown').click().focus();
		//$('.btnHamburger.btnDropDown').promise().done(function() {
		//    $('.btnHamburger.btnDropDown').next().children('li:first-child').find('a').focus();
		//});
	}
}

function hide_menue_callback(menuType, focusEntNeeded)
{
	$('.personalMenu').addClass("displayNone");
	$('.add .dropMenu,.dropMenu').addClass("displayNone");
	$('.hamburgerMenu').find('.toolBar').remove();
	$('.helpContainer').find('ul').remove();
	$('.advancedQueryList').addClass('displayNone');	
	focusEntNeeded && focusEnt();
}

//////
//Show the last menue was displayed before it closed
//////
function show_last_active_main_menue()
{
   if (currentMenueActive != null && currentMenueActive.length > 0 && $(currentMenueActive).closest('.menue_li.active').length > 0) {
			if (currentMenueActive.parent().hasClass('displayNone')) {
				//$(currentMenueActive).parent().children('li').removeClass('active');
				$(currentMenueActive).closest('.menue_li.active').children('a').click();
			}
			else {
				$(currentMenueActive).closest('.menue_li.active').children('a').focus();
			}
		} else {
			$('#mainMenu li:first-child a').click().focus();
		}
}

	
esearch_doclist = function (result)
{
	// gwt use: esearchDocList() 
	window.alert("esearch_doclist not implemented:\n" + result);
}

var doESearch; // initialized by text widget
var callbacks = {
	ClearCallback: null,
	MenuChangeCallback: global_callback_change,
	ActiveChangeCallback: global_callback_active,
	DateRangeChangeCallback: global_callback_date_range,
	LangCallback: global_lang,
	UsernameCallback: global_username,
	TrialDaysRemainingCallback: trial_days_remaining,
	MenuCompanyChangeCallback: global_menu_company_change,
	FormCompanyChangeCallback: global_form_company_change,
	EntTitleChangedCallback: null,
	InitCallback: init_params,
	HomeChangeCallback: home_page_display_change,
	OpenEntChangeCallback: open_ent_change,
	ESearchAcCallback : esearch_ac_callback, // see search.js
	ESearchFindCallback: esearch_find_callback, // see search.js
	FocusMenuCallback:focus_menu_callback,
	HideMenuCallback: hide_menue_callback,
	PrivTreeHandlerCallback : priv_tree_handler_callback,
	ColLogicHandlerCallback : col_logic_handler_callback,
	illegalOperationCallback : illegal_operation_callback,
	xmlUpdate : xml_update
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/* Menue Display functions*/
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
var personalMenuActive=true;

function personal_item_menue_click(menutype, fatexec, exec, etype, ename,  type, e)
{
	if (personalMenuActive != true)
		return;
	var menuItem = $("#personal_menue_item_" + exec);
	menuItem.parent().addClass("active");
	menuItem.parent().siblings(".active").removeClass("active");
	currentPersonalMenueActive = $('.personalMenu').find('li.active');
	e.preventDefault();
	e.stopPropagation();
	hide_home_page(etype);
	hide_menu(etype);
	menuClickNew(menutype, fatexec, exec, etype, ename, type);
	$('#menuholder input[type="text"]').off();
	$('#menuholder input[type="text"]').on('click, focus', function (e) {
		$('.personalMenu').addClass("displayNone");
		$('.add .dropMenu,.dropMenu').addClass("displayNone");
		$('.hamburgerMenu').find('.toolBar').remove();
		$('.helpContainer').find('ul').remove();
		$('.advancedQueryList').addClass('displayNone');
	});
	
}

function lastUpdates_item_menue_click(ename, docNo,etype)
{
	var menuItem = $("#personal_menue_item_" + docNo);
	menuItem.parent().addClass("active");
	menuItem.parent().siblings(".active").removeClass("active");
	currentPersonalMenueActive = $('.personalMenu').find('li.active');
	
	window.monitor.sendMonitor && window.monitor.sendMonitor('Home_Latest');

	hide_home_page(etype);
	hide_menu(etype);
	startEnt(ename, docNo, "", 0);
	$('#menuholder input[type="text"]').off();
	$('#menuholder input[type="text"]').on('click, focus', function (e) {
		$('.personalMenu').addClass("displayNone");
		$('.add .dropMenu,.dropMenu').addClass("displayNone");
		$('.hamburgerMenu').find('.toolBar').remove();
		$('.helpContainer').find('ul').remove();
		$('.advancedQueryList').addClass('displayNone');
	});
   
}

function toolbar_item_menue_click(event, menutype, fatexec, exec, etype, ename,  type, enabled)
{	
	// $('.toolBar.dropDown').find("li:first-child").removeClass("active");
	 
	// Removing active class from pevious list item
	if(fatexec == 1260){
		$('.toolBar.dropDown').find("li.active").parent().find("li").children().removeClass("select-v");
		$(event.target).addClass("select-v");
	}
	$('.toolBar.dropDown').find("li.active").removeClass("active");
	// Adding active class to the new one
	$(event.target).parent().addClass("active");
	$(event.target).parent().siblings().find("ul.dropMenu").remove();
	if (enabled == 1) {
		if($(event.target).parent().find(".dropMenu").length == 0)
		{
			menuClickNew(menutype, fatexec, exec, etype, ename,  type);
			if(type != "Menu")
			{
				$(".toolBar").find("li").remove();
			}
			if (type == 'Item') {
				$('#hamburgerMenu').find('ul').remove();
			}
		}
	}
}

function hamburger_menu_click() {
	menuClickNew(5, 0, 0, "", "", "");

	$('.toolBar.dropDown').find("li:first-child").addClass("active").focus();
	$('.personalMenu').addClass("displayNone");
	$('ul:not(.add .dropMenu)', '#mainMenu').addClass("displayNone");
	if ($('.helpContainer').find('ul').length > 0) {
		$('.helpContainer').find('ul').remove();
	}
	$(".advancedQueryList").addClass("displayNone");
}

function hide_home_page(etype) {
	if (etype !== "P" && etype !== "M" && etype !== "R") {
		$(".wrapper").addClass("displayNone");
		$("body").removeClass("body-overflow");
	} 
}

function hide_menu(etype) {
	if (etype !== "M") {
		$(".personalMenu").addClass("displayNone");
		$('ul', '#mainMenu').addClass("displayNone");//$('ul:not(".personalMenu")', '#mainMenu').remove();
		$(".topMenuPanelStyle").addClass("displayNone");
		$("body").css("height", "100%");
	}
	hide_search_popup(etype);
}

function hide_search_popup(etype) {
	if (etype !== "M") {
		$('#esearchPopup').addClass("displayNone");
	}
	
}

function hideEsearchBtnClick() {
	$('#hideEsearchBtn').on('click keydown', function () {
	if(!$('main.wrapper').hasClass('displayNone'))
	{
	show_home_page();
	}      
	});
}



function show_home_page() { 
	$(".wrapper").removeClass("displayNone");
	$(".btnAdvanced").addClass("displayNone");
	$(".topMenuPanelStyle").addClass("displayNone");
	$("body").addClass("body-overflow");
	$("body").removeAttr("height", "auto");
	$('#esearchPopup').addClass("displayNone");
}


function personal_menu_click() {
	if ($(".personalMenu").hasClass("displayNone")) {
		if (currentPersonalMenueActive == null) {
			currentPersonalMenueActive = $('.personalMenu').find('li');
		}
		else {
			currentPersonalMenueActive = $('.personalMenu').find('li.active');
		}
		$(".personalMenu").removeClass("displayNone");
        $(".personalMenu").find(".displayNone").removeClass("displayNone");
		$('#personal_menu').focus();
		
		$('.hamburgerMenu').find('.toolBar').remove();
		$('.helpContainer').find('ul').remove();
		
	} else {
		$(".personalMenu").addClass("displayNone");
	}
}

function advanced_query_click(e) {
	$(".advancedQueryList").toggleClass("displayNone");   
}


function side_menu_click() {
	$(".topMenuPanelStyle").on("click mouseover", function(){
		 $(".gwt-MenuBar-vertical").parents(".gwt-MenuBarPopup").addClass("topSubMenu").on("click mouseover", function(){
			$(".topSubMenu").next(".gwt-MenuBarPopup").addClass("topSubMenu-2");
		 });
	});
}

function opened_window_menu() {
		openNavigationDlg();
}

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/* Menue Kebourd nevigation*/
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

function menue_key_event(e) {
	e.preventDefault();
	e.stopPropagation();
	var keyCode = e.keyCode;

	if ($(currentMenueActive) != undefined && $(currentMenueActive) != null) {

		var clickedItemParent = $(currentMenueActive).parent();
		if (clickedItemParent.hasClass("mainMenu")) {
			if (keyCode == 38) {
				return;
			}
			else if (keyCode == 39) {
			 if(systemLanguage == 1) {
				keyCode = 38;
				}
				else
				{
					keyCode = 40;
				}
			}
			else if (keyCode == 40) {
				keyCode = 13;
			}
			else if (keyCode == 37) {
			 if(systemLanguage == 1) {
					keyCode = 40;
				}
				else
				{
					keyCode = 38;
				}
			}
		}
	}
  
	if (keyCode == 112) {
		MenuKeyPress(e,"F1");
		e.preventDefault();
		e.stopPropagation();
		return false;
	}

	if (keyCode == 117) {
		MenuKeyPress(e,"F6");
		return false;
	}
	
	if(keyCode == 13)
	{
		leftArrowClick(e.target);
	}
	
	if (keyCode == 37) {
		if(systemLanguage == 1) {
			leftArrowClick(e.target);
			return false;
		} else {
			rightArrowClick(e.target);
			return false;
		}
	}
	else if (keyCode == 38) {
		upArrowClick(e.target);
		return false;
	}
	else if (keyCode == 39) {
		if(systemLanguage == 1) {
			rightArrowClick(e.target);
			return false;
		} else {
			leftArrowClick(e.target);
			return false;
		}
	}
	else if (keyCode == 40) {
		downArrowClick(e.target);
		return false;
	}
	else if (keyCode == 27) {
		hide_menu('X');
		hide_search_popup();
		$(".advancedQueryList").addClass("displayNone");
		currentMenueActive = null;
	  //  $('.mainMenu li').removeClass('active');
	  //  $('.mainMenu li:first-child').addClass('active');
	 //   $('.mainMenu li:first-child > a').focus();
		focusEnt();
		e.preventDefault();
		e.stopPropagation();
		return false;
	}
}

function MenuKeyPress(e,key) {
	var clickFunc;
	var values;
	var keyPrees = key;
	if ($(e.target).closest('li.menue_li.active').length > 0) {
		clickFunc = $(e.target).closest('li.menue_li.active').find('.active').last().find('a').attr("onclick");
		clickFunc = clickFunc.replace(')', '');
		values = clickFunc.split(',');
		var lastValue = values[0].replace("global_click(","").trim();
		var frame = GLOBAL_MRK_MENU.currentFrame.elements;
		var currentFramePress;
		if (frame != null) {
			$.each(frame, function(index, value) {
				if (value.ex == lastValue) {
					currentFramePress = value;
					return;
				}
			});
		}
		if (currentFramePress !== undefined && currentFramePress!==null) {
			if(key === "F1"){
				window.genPage.setHelpElement($(e.target).closest('li.menue_li.active').find('.active').last().find('a')[0])
			}
			menuKey(0, currentFramePress.fatexec, parseInt(currentFramePress.ex), currentFramePress.etype, currentFramePress.ename, currentFramePress.type, keyPrees);
		}
	}
	else if ($(e.target).closest('#btnFavorite').length > 0) {
		clickFunc = $(e.target).closest('#btnFavorite').find('li.active').last().find('a').attr("onclick");
		clickFunc = clickFunc.replace("personal_item_menue_click(", "").replace(")", "");
		values = clickFunc.split(',');
		if (values !== undefined && values !== null && values.length > 0) {
			menuKey(parseInt(values[0]), parseInt(values[1]), parseInt(values[2]), values[3].replace("'", "").replace("'", ""), values[4].replace("'", "").replace("'", ""), values[5].replace("'", "").replace("'", ""), keyPrees);
		}
	}
}

function hamburgerMenu_key_event(e) {
	if (e.keyCode == 37 || e.keyCode == 13) {
		if (systemLanguage == 1) {
			hamLeftArrowClick(e.target);
			return false;
		} else {
			hamRightArrowClick(e.target);
			return false;
		}
	}
	else if (e.keyCode == 38) {
		hamUpArrowClick(e.target);
		return false;
	}
	else if (e.keyCode == 39) {
		if (systemLanguage == 1) {
			hamRightArrowClick(e.target);
			return false;
		} else {
			hamLeftArrowClick(e.target);
			return false;
		}
	}
	else if (e.keyCode == 40) {
		hamDownArrowClick(e.target);
		return false;
	}
	else if (e.keyCode == 27) {
		hide_menu('X');
		hide_search_popup();
		$('.mainMenu li').removeClass('active');
		$('.mainMenu li:first-child').addClass('active');
		$('.mainMenu li:first-child > a').focus();
		$("#hamburgerMenu").find("ul.toolBar").remove();
		focusEnt();
		e.preventDefault();
		e.stopPropagation();
		return false;
	}
	e.preventDefault();
	e.stopPropagation();
}

function rightArrowClick(curruntNode) {
	var curBtn = $(curruntNode).next(".dropMenu");
	currentMenueActive = curBtn.find('li.active').last();
    if(currentMenueActive.length==0){
        currentMenueActive= $(curruntNode).closest("ul.mainMenu").find('li.active').last();
    }
	if ($(curruntNode).next('ul').length == 0 && $(curruntNode).parentsUntil('ul:first-child').parent().parent().hasClass("add") && $(curruntNode).closest('.add').hasClass('active')
		|| $(curruntNode).attr('id') === "openPlusMenu" && $(curruntNode).closest('.add').hasClass('active')) {
		$('.add').find('ul').toggleClass('displayNone');
		//$(curruntNode).closest('.menue_li.add').addClass('active');
		currentMenueActive = $(curruntNode).closest('.menue_li.add');
		currentMenueActive.children('a').focus();
		return;
	}

	var clickedItemParent = $(currentMenueActive).parent();

	if (!clickedItemParent.hasClass("mainMenu") && !clickedItemParent.parent().hasClass('btnFavorite')) {
		var clickepParentPrev = clickedItemParent.prev();
		if (clickedItemParent.parent('li.add').length > 0) {
			plusMenuUl = clickedItemParent;
		}
		clickedItemParent.remove();
	  //clickepParentPrev.parent().addClass("active");
	  currentMenueActive =  clickepParentPrev.parent();
	  currentMenueActive.parent().addClass("lastMenu");
	}
	else if (clickedItemParent.parent().hasClass('btnFavorite')) {
		clickedItemParent.addClass('displayNone');

	}
	//else if ($(curruntNode).hasClass('btnFavorite')) {
	//    var clickepParentPrev = clickedItemParent.prev();
	//    currentMenueActive = clickepParentPrev.parent();
	//    currentMenueActive.parent().addClass("lastMenu");
	//}
	
}

function leftArrowClick(curruntNode) {
	var isPersonalMenuItem = $(curruntNode).parent().hasClass('btnFavorite');
    var clickFunc;
   if($(currentMenueActive).find('li.active a').length>0){
       clickFunc = $(currentMenueActive).find('li.active > a').last().attr("onclick");
   }
   else if(isPersonalMenuItem && currentMenueActive==null){
	 clickFunc = $(curruntNode).next("ul").find('li.active > a').last().attr("onclick");       
   }
   else{
	 clickFunc = $(currentMenueActive).find('a').attr("onclick");       
   }

	//console.log('clickFunc', clickFunc);
	//console.log('currentMenueActive', currentMenueActive.get(0));


	// Checking solution for empty menus
	if (clickFunc == undefined) {
		//console.log('UNDEFINED');
		//console.log('curruntNode', curruntNode);
		// currentMenueActive = curruntNode.parent();
		// clickFunc = '0, 0)';
		global_click(18738, 10168);
		//console.log('clickFuncUnd', clickFunc);
		// curBtn.find('li').last().addClass('active');
		// currentMenueActive = curBtn.find('li').first();
		return;
	}

	//console.log('clickFunc', clickFunc);

	if (clickFunc !== "openPlusMenu()") {
		if (!isPersonalMenuItem) {
			clickFunc = clickFunc.replace('global_click(', '');
		} else {
			clickFunc = clickFunc.replace('personal_item_menue_click(', '');
		}
		clickFunc = clickFunc.replace(')', '');
		var values = clickFunc.split(',');

		if (!isPersonalMenuItem) {
			global_click(values[0], values[1]);
		} else {
			var arg4 = values[3].replace(/\'/g, "");
			var arg5 = values[4].replace(/\'/g, "");
			var arg6 = values[5].replace(/\'/g, "");
			personal_item_menue_click(parseInt(values[0]), parseInt(values[1]), parseInt(values[2]), arg4, arg5, arg6, event);
		}
	} else if (clickFunc === "openPlusMenu()") {
		openPlusMenu();
		//$(currentMenueActive).children('ul').children('li:first-child').addClass('active').find('a').click();
		//$(currentMenueActive).closest('.add').addClass('active');
		//$(currentMenueActive).children('ul').children('li:first-child').find('a').click();
	} 
}

function downArrowClick(curruntNode) {

	var curBtn = $(curruntNode).next(".dropMenu");
	 if (curBtn.attr('id') === 'openPlusMenu' || curBtn.prev().attr('id') === 'openPlusMenu') {
		 curBtn = $(curruntNode).closest('.mainMenu').find('li.active').last();
	 curBtn.focus();
	 } else {
		 curBtn = ($(curBtn).length > 0) ? $(curruntNode).next(".dropMenu") : $(curruntNode).children("ul.dropMenu");
	 }
	if (curBtn.find('li').length > 0) {
		currentMenueActive = curBtn.find('li.active').last();
		if (currentMenueActive == null) {
			curBtn.find('li').first().addClass('active');
			currentMenueActive = curBtn.find('li').first();
		}
		else {
			currentMenueActive.removeClass('active');

			if (currentMenueActive.next().not('.lastItem').length) {
				currentMenueActive = currentMenueActive.next();
				currentMenueActive.addClass('active');
				if(currentMenueActive.hasClass("hideItem"))
					showScrollItemDown(currentMenueActive);
			}
			else {
				$(currentMenueActive).closest('ul').children('li:not(.firstItem):first').addClass('active');
				//curBtn.find('li').first().addClass('active');
				//currentMenueActive = curBtn.find('li').first();
				if (currentMenueActive.length > 0) {
					currentMenueActive = $(currentMenueActive).closest('ul').children('li:not(.firstItem):first');
					if(currentMenueActive.hasClass('hideItem'))
						resetScrollItemDown(currentMenueActive.parent());
				} else {
					currentMenueActive = curBtn.find('li').first();
				}
			}
		}
	}
	// go down in current menu
	else {
		var curBtn = currentMenueActive; //currentMenueActive.children(".active");
		if (curBtn.next("li").length > 0) {
			curBtn.removeClass("active").next("li").addClass("active");
			currentMenueActive = currentMenueActive.next();
		}
	}
}

function upArrowClick(curruntNode) {

	var curBtn = $(curruntNode).next(".dropMenu");
	if (curBtn.attr('id') === 'openPlusMenu' || curBtn.prev().attr('id') === 'openPlusMenu') {
		curBtn = curBtn.closest('.add');
		curBtn.focus();
	}
	if (curBtn.find('li').length > 0) {
	currentMenueActive = curBtn.find('li.active').last();
		if (currentMenueActive == null) {
			curBtn.find('li').last().addClass('active');
			currentMenueActive = curBtn.find('li').first();
		}
		else {
			
			currentMenueActive.removeClass('active');
			
			if (currentMenueActive.prev().not('.firstItem').length) {	
				currentMenueActive = currentMenueActive.prev();
				currentMenueActive.addClass('active');
				if(currentMenueActive.hasClass("hideItem"))
					showScrollItemUp(currentMenueActive);
			}
			else {
				currentMenueActive = currentMenueActive.parent().find('li:not(.lastItem):last');
				currentMenueActive.addClass('active');
				if(currentMenueActive.hasClass('hideItem'))
					resetScrollItemUp(currentMenueActive.parent());
				//curBtn.find('li').last().addClass('active');
			   // currentMenueActive = curBtn.find('li').last();				
			}
		}
	}
	// go up in current menu
	else {
		var curBtn = currentMenueActive; //currentMenueActive.children(".active");
		if (curBtn.prev("li").length > 0) {
			curBtn.removeClass("active").prev("li").addClass("active");
			currentMenueActive = currentMenueActive.prev();
		}
	}
}

function resetScrollItemDown(currentScrollMenue) {
	if(!currentScrollMenue.hasClass("scrollMenue"))
		return;
	currentScrollMenue.children(".hideItem").removeClass("hideItem");
	currentScrollMenue.children(".lastItem").prev().addClass("hideItem");
	while ((currentScrollMenue.height() + currentScrollMenue.offset().top + 5) > window.innerHeight) {
		currentScrollMenue.children(".hideItem:first").prev().addClass("hideItem");
	}
	
	scrollClick(currentScrollMenue);
}

function resetScrollItemUp(currentScrollMenue) {
	if(!currentScrollMenue.hasClass("scrollMenue"))
		return;
	currentScrollMenue.children(".hideItem").removeClass("hideItem");
	currentScrollMenue.children(".firstItem").next().addClass("hideItem");
	while ((currentScrollMenue.height() + currentScrollMenue.offset().top + 5) > window.innerHeight) {
		currentScrollMenue.children(".hideItem:last").next().addClass("hideItem");
	}
	
	scrollClick(currentScrollMenue);
}


function showScrollItemDown (currentScrollMenue) {
	
	if(!currentScrollMenue.hasClass("hideItem"))
		return;
	
	currentScrollMenue.removeClass("hideItem");
	currentScrollMenue = currentScrollMenue.parent();
	
	do {
		currentScrollMenue.children().not(".firstItem").not(".hideItem").first().addClass("hideItem");
	} while ((currentScrollMenue.height() + currentScrollMenue.offset().top + 5) > window.innerHeight);
	
	scrollClick(currentScrollMenue);
	
	if (currentScrollMenue.children('.active').hasClass('hideItem')) {
		currentScrollMenue.children('.active').removeClass('active');
		currentScrollMenue.children().not('.firstItem').not('.hideItem').first().addClass('active');
		currentMenueActive = currentScrollMenue.find('li.active').last();		
	}
}

function showScrollItemUp (currentScrollMenue) {
	
	if(!currentScrollMenue.hasClass("hideItem"))
		return;
	
	currentScrollMenue.removeClass("hideItem");
	currentScrollMenue = currentScrollMenue.parent();
	
	do {
		currentScrollMenue.children().not(".lastItem").not(".hideItem").last().addClass("hideItem");
	} while ((currentScrollMenue.height() + currentScrollMenue.offset().top + 5) > window.innerHeight);
	
	scrollClick(currentScrollMenue);
	
	if (currentScrollMenue.children('.active').hasClass('hideItem')) {
		currentScrollMenue.children('.active').removeClass('active');
		currentScrollMenue.children().not('.lastItem').not('.hideItem').last().addClass('active');
		currentMenueActive = currentScrollMenue.find('li.active').last();
	}
}

function hamRightArrowClick(curruntNode) {
    if(systemLanguage==1){
	var clickedItemParent = $(curruntNode).closest('ul');
	if (clickedItemParent.hasClass("dropDown") || clickedItemParent.hasClass("dropMenu")) {
		var clickepParentPrev = clickedItemParent.prev();
		clickepParentPrev.closest('#hamburgerMenu').find('a').first().focus();
		clickedItemParent.remove();
		//clickepParentPrev.parent().addClass("active");
		currentHamburgerMenueActive = clickepParentPrev.parent();
		currentHamburgerMenueActive.parent().addClass("lastMenu");
	}
    }
else{
    hamLeftArrowClick(curruntNode);
}
}

function hamLeftArrowClick(curruntNode) {

	var $node = $(curruntNode);
	if ($(curruntNode).hasClass('btnHamburger')) {
		$node = $(curruntNode).next().find('.active a');
		$node.click();
		$node.next().find('li:first-child').addClass('active');
		$node.next().find('li:first-child a').focus();
		$node.next().find('li a').keydown(function (e) {
			//hamburgerMenu_key_event(e);
		});
	} else if ($(curruntNode).closest('ul.lastMenu').length > 0 && $(curruntNode).parent("li").hasClass("active")) {
        if(systemLanguage==1){
		$node.click();
		if ($node.next().find('li').length > 0) {
			$node.next().find('li:first-child').addClass('active');
			$node.next().find('li:first-child a').focus();
		} 
        else{
            $node.click();
        }
        }
        else{
            if(event.keyCode==13 || event.keyCode==39){
			$node.click();
                return;
            }
           var clickedItemParent = $(curruntNode).closest('ul');
	if (clickedItemParent.hasClass("dropDown") || clickedItemParent.hasClass("dropMenu")) {
		var clickepParentPrev = clickedItemParent.prev();
		clickepParentPrev.closest('#hamburgerMenu').find('a').first().focus();
		clickedItemParent.remove();
		//clickepParentPrev.parent().addClass("active");
		currentHamburgerMenueActive = clickepParentPrev.parent();
		currentHamburgerMenueActive.parent().addClass("lastMenu");
		}
	}
}
    else if ($(curruntNode).closest('ul.toolBar.dropDown').length > 0){
            $node=$(curruntNode).closest('ul.toolBar.dropDown').find("li.active a");
            $node.focus();
			$node.click();
		}
}

function hamDownArrowClick(curruntNode) {

	var curBtn = $(curruntNode).next(".dropDown");
	if (curBtn.length == 0) {
		curBtn = $(curruntNode).closest('ul.dropMenu');
		curBtn.children('li').removeClass('active');
		currentHamburgerMenueActive = $(curruntNode).parent();

		// Looking for the mouse + keyboard navigation bug
		//console.log('curBtn', curBtn);
		///console.log('currentHamburgerMenueActive', currentHamburgerMenueActive);
	}
	if (curBtn.find('li').length > 0) {
		currentHamburgerMenueActive = curBtn.find('li.active').last().length > 0 ? curBtn.find('li.active').last() : currentHamburgerMenueActive;
		if (currentHamburgerMenueActive == null) {
			curBtn.find('li').first().addClass('active');
			currentHamburgerMenueActive = curBtn.find('li').first();
		}
		else {
			currentHamburgerMenueActive.removeClass('active');

			if (currentHamburgerMenueActive.next().length) {
				currentHamburgerMenueActive = currentHamburgerMenueActive.next();
				currentHamburgerMenueActive.addClass('active');
				if (!$(currentHamburgerMenueActive).closest('ul').hasClass('toolBar'))
					{
					currentHamburgerMenueActive.children('a').focus();
				}
			}
			else {
				$(currentHamburgerMenueActive).closest('ul').children('li:first-child').addClass('active').find('a').focus();
				//curBtn.find('li').first().addClass('active');
				//currentHamburgerMenueActive = curBtn.find('li').first();
				if (currentHamburgerMenueActive.length > 0) {
					currentHamburgerMenueActive = $(currentHamburgerMenueActive).closest('ul').children('li:first-child');
				} else {
					currentHamburgerMenueActive = curBtn.find('li').first();
				}
			}
		}
	}
		// go down in current menu
	else {
		var curBtn = $(currentHamburgerMenueActive).closest("ul").find("li.active"); //currentMenueActive.children(".active");
        //console.log(curBtn[0]);
		if (curBtn[0].nextSibling) {
			curBtn[0].className='';
            curBtn[0].nextSibling.className='active';
            curBtn[0].nextSibling.focus();
			currentHamburgerMenueActive = curBtn[0].nextSibling;
		}
        else{
        curBtn = $(currentHamburgerMenueActive).closest("ul").find("li").removeClass("active").first();
        curBtn.focus();
        currentHamburgerMenueActive=curBtn;
           curBtn.addClass("active");
		}
	}
}

function hamUpArrowClick(curruntNode) {

	var curBtn = $(curruntNode).next(".dropDown");
	if (curBtn.length == 0) {
		curBtn = $(curruntNode).closest('ul.dropMenu');
		currentHamburgerMenueActive = $(curruntNode).parent();

		// Looking for the mouse + keyboard navigation bug
		//console.log('curBtn', curBtn);
		//console.log('currentHamburgerMenueActive', currentHamburgerMenueActive);
	}
	if (curBtn.find('li').length > 0) {
		if (currentHamburgerMenueActive == null) {
			curBtn.find('li').last().addClass('active');
			currentHamburgerMenueActive = curBtn.find('li').first();
		}
		else {
			currentHamburgerMenueActive.removeClass('active');

			if (currentHamburgerMenueActive.prev().length) {
				currentHamburgerMenueActive = currentHamburgerMenueActive.prev();
				currentHamburgerMenueActive.addClass('active');
				if (!$(currentHamburgerMenueActive).closest('ul').hasClass('toolBar')) {
					currentHamburgerMenueActive.children('a').focus();
				}
			}
			else {
				$(currentHamburgerMenueActive).closest('ul').children('li:last-child').addClass('active').find('a').focus();
				//curBtn.find('li').last().addClass('active');
				//currentHamburgerMenueActive = curBtn.find('li').last();
				if (currentHamburgerMenueActive.length > 0) {
					currentHamburgerMenueActive = $(currentHamburgerMenueActive).closest('ul').children('li:last-child');
				} else {
					currentHamburgerMenueActive = curBtn.find('li').last();
				}
				
			}
		}
	}
		// go up in current menu
	else {
		var curBtn = currentHamburgerMenueActive.closest("ul").find("li.active"); //currentMenueActive.children(".active");
		if (curBtn.prev("li").length > 0) {
			curBtn.removeClass("active").prev("li").addClass("active");
			currentHamburgerMenueActive = currentHamburgerMenueActive.prev();
		}
        else{
            curBtn = currentHamburgerMenueActive.parent("ul.toolBar.dropDown").find("li.active");
		if (curBtn.prev("li").length > 0) {
			curBtn.removeClass("active").prev("li").addClass("active");
			currentHamburgerMenueActive = currentHamburgerMenueActive.prev();
		}
        else{
            curBtn = currentHamburgerMenueActive.parent("ul.toolBar.dropDown").find("li").removeClass("active").last("li").addClass("active");
            currentHamburgerMenueActive = curBtn;
        }
        }
	}
}

function openPlusMenu(){
	if ($("li.add ul").length == 0) {
		$("li.add").append(plusMenuUl);
		$("li.add ul").addClass('displayNone');
	}
	if ($("li.add ul").hasClass("displayNone"))
	{
		$("li.add ul").removeClass("displayNone");
		$("li.add ul").parent().find('a').first().focus();
		$("li.add").addClass('active');
		downArrowClick($("li.add > a:first-child"));
		$("li.add ul li").removeClass('active');
		$("li.add ul li:first-child").addClass("active");
	}
	else{
		$("li.add ul").addClass("displayNone");
		$("li.add li").removeClass('active');

	}
}
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/* MrkMenuElement object => one element in menu */
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/* constructor 
	ex = entity id
	ename = entity internal name
	etype = entity type
	title = entity title
	type = icon type
	*/
MrkMenuElement = function (fatexec, ex, ename, docno, details, etype, title, type, countissues, help, enabled, checked, icontype, shortcuts, icon) {
	this.fatexec = fatexec;
	this.ex = ex;
	this.ename = ename;
	this.docNo = docno;
	this.details = details;
	this.etype = etype;
	this.title = title;
	this.type = type;
	this.countissues = countissues;
	this.help = help;
	this.enabled = enabled;
	this.checked = checked;
	this.icontype = icontype;
	this.shortcuts = shortcuts;
	this.icon = icon;
};

/* MrkMenuFrame object => one frame of menu */
MrkMenuFrame = function (id, parentFrame, xmlData, menuType) {
	this.id = id;
	this.elements = new Array();
	this.menuType = menuType;

	if (parentFrame != null)
		this.offset = parentFrame.offset + 30;
	else
	   this.offset = 0;

	this.nextFrame = null;
	this.parentFrame = parentFrame;

	this.xmlToElements(id,xmlData);
	this.draw();
};

function create_element_array_from_xml(ex,xmlDoc)
{
	var elementArray = new Array();
	$(xmlDoc).find('Menu').each(function () {
		var elem = new MrkMenuElement(ex,
			$(this).find('exec').first().text(),
			$(this).find('ename').first().text(),
			$(this).find('docNo').first().text(),
			$(this).find('details').first().text(),
			$(this).find('etype').first().text(),
			$(this).find('title').first().text(),
			$(this).find('type').first().text(),
			$(this).find('countIssues').first().text(),
			$(this).find('help').first().text(),
			$(this).find('enabled').first().text(),
			$(this).find('checked').first().text(),
			$(this).find('icontype').first().text(),
			$(this).find('shortcut').first().text(),
			$(this).find('icon').first().text());
		elementArray.push(elem);
	});
	return elementArray;
}

function select_query_callback(ex) {
	menuClickNew(4, 0, ex, "", "", "");
	$(".advancedQueryList").toggleClass("displayNone");
}

MrkMenuFrame.prototype.xmlToElements = function (ex,xmlData) {
	if (this.elements.length > 0)
		this.elements = {};

	var $x = xmlData.replace('<?xml version="1.0" encoding="UTF-8"?>', '<?xml version="1.0" encoding="UTF-8"?><root>');
	$x += '</root>';

	xmlDoc = $.parseXML($x), $xml = $(xmlDoc);

	GLOBAL_ELEMENTS = create_element_array_from_xml(ex,xmlDoc);
	this.elements = GLOBAL_ELEMENTS;
	GLOBAL_ELEMENTS = null;
};

MrkMenuFrame.prototype.reload = function (ex,xmlData) {
	//this.erase();

	this.xmlToElements(ex,xmlData);

	this.draw();
};

MrkMenuFrame.prototype.draw = function () {
	if (this.id != 0) {
		//$("a[id^=merk_menu_item").css("display", "none");
		//Ido: here is the bug
		
		// if($("#merk_menu_item_" + this.id).hasClass("merk_menu") && $("#merk_menu_item_" + this.id).children() == 0)
		// {
		// 	$('.dropMenu lastMenu').find('li').remove();		
		// }
		
		if ($("#merk_menu_item_" + this.id).children().not('.arrow-icon').length > 1) {
			$("#merk_menu_item_" + this.id).parent().addClass("open");
		}
		else if ($("#merk_menu_item_" + this.id).siblings().length == 0) {
			var lastMenuOpen = $(".lastMenu").length > 0 ? $(".lastMenu") : $("#merk_menu_item_" + this.id).closest("ul.dropMenu");
			var cssClass = "";
			var diffWidth;
			var diffHeight;
			//check if menus width overflow window boundaries, if so, we move them inside
			if (lastMenuOpen.length > 0) {
				diffWidth = systemLanguage == 1 ? lastMenuOpen.offset().left : window.innerWidth - (lastMenuOpen.offset().left + lastMenuOpen.width());
				if (diffWidth < lastMenuOpen.width()) {
					cssClass = systemLanguage == 1 ? "openMenuToTheRight" : "openMenuToTheLeft"
				}
			}
			$(".lastMenu").removeClass("lastMenu");
			$('.merk_menu').removeClass("visible");
			// var $ul = $("<ul class='dropMenu lastMenu' style=\"display: block;\">", {});
			var $ul = $("<ul class='dropMenu lastMenu visible'>", {});
			$ul.addClass(cssClass);
			for (i = 0; i < this.elements.length; i++) {
			    var $li = $("<li>", {});
				var liClass = "class='merk_menu_item_" + this.elements[i].icontype;
				if(this.elements[i].ename === "LOADCREDITPAGES"){
					liClass +=" fid_" + window?.featuresIDs?.creditCardReconID;
				}
				if (window.inline_manual_player)
				    liClass += " " + this.elements[i].ename + "_" + this.elements[i].etype;
				liClass += "'";
								$li.append($("<a href=\"#\" " + liClass + "title=\"" + this.elements[i].title.replace(/"/g,"&quot") + "\"  id=\"merk_menu_item_" + this.elements[i].ex + "\" onclick=\"global_click(" + this.elements[i].ex + ", " + this.id + ")\">", {/*class: $cl*/ })
								.append(this.elements[i].title)
								.append("<div class=\"merk_menuoptions\" onmousedown=\"{ global_click(" + this.elements[i].ex + ", " + this.id + ", event.clientX , event.clientY );}\">&nbsp;&nbsp;⋮&nbsp;&nbsp;</div>"));
				$ul.append($li);
			}

			$("#merk_menu_item_" + this.id).parent().append($ul);
			//check if menus height overflow window boundaries, if so, we move them inside
			if ($(".lastMenu").length > 0 && !$(".lastMenu").parent().hasClass("menue_li")) {
				diffHeight = window.innerHeight - ($(".lastMenu").height() + $(".lastMenu").offset().top + 20);
				if (diffHeight >= 0)
					diffHeight= -1;
				else
					diffHeight = (-diffHeight <= ($(".lastMenu").offset().top -20)) ? diffHeight : -($(".lastMenu").offset().top - 20) ; 
				$ul.css('top', diffHeight + "px");
			}
			
			if(window.innerHeight < ($ul.offset().top  + $ul.height() + 5)) {
				$ul.addClass("scrollMenue");
				$ul.prepend('<li class="firstItem"></li>');
				$ul.append('<li class="lastItem"></li>');
				$ul.children(".lastItem").prev().addClass("hideItem");
				while (($(".lastMenu").height() + $(".lastMenu").offset().top + 5) > window.innerHeight) {
					$ul.children(".hideItem:first").prev().addClass("hideItem");
				}
				scrollClick($ul);
			}
			
			var parentLi = $("#merk_menu_item_" + this.id).parent();
			if (!parentLi.hasClass("active")) {
				parentLi.siblings("li.active").removeClass("active");
				parentLi.addClass("active");
			}
			currentMenueActive = $ul.find('li').not('.firstItem').not('.hideItem').first();
			currentMenueActive.addClass('active');

		}
	}
	else {
		var extraMenueArray = [];
		var currMenuWidth = 0;
		var currNavbarWidth = $(".bottomHeader").width();
		var companyNameWidth = $("#companyName").width();
		$('#mainMenu').find('li').remove();
		
		// Loging keydown binding
		// console.log('this', this);
		// console.log('this.elements', this.elements);

		if(this.elements.length > 0)
		{
			for (i = 0; i < this.elements.length; i++) {
				currMenuWidth = $('#mainMenu').width();
				var $li = $("<li class='menue_li'>", {});
				var liClass = "class='merk_menu";
				if (window.inline_manual_player)
				    liClass += " " + this.elements[i].ename + "_" + this.elements[i].etype;
				liClass += "'";
				var $a = $("<a href=\"#\" " + liClass +  "title=\"" + this.elements[i].title.replace(/"/g,"&quot") + "\" id=\"merk_menu_item_" + this.elements[i].ex + "\" onclick=\"global_click(" + this.elements[i].ex + ", " + this.id + ")\">", {/*class: $cl*/ })
				$a.append(`<span class='title'>${this.elements[i].title}</span>`);
				if(this.elements[i].etype === "M" && this.menuType === 1){
					$a.append($("<span class='arrow-icon'></span>"))
				}
				$li.append($a);
				//if the menu size is about to reach the navbar size we need to push the next items in the extraMenuArray
				if (currMenuWidth >= currNavbarWidth - (companyNameWidth + 300)) {
					extraMenueArray.push($li);
				}
				else {

					$('#mainMenu').append($li);
				}

			}
		}

		
		if (extraMenueArray.length > 0) {
			$('#mainMenu').append("<li class=\"menue_li add\"><a href=\"#\" title=\"\"  id=\"merk_menu\" onclick=openPlusMenu()>+</a></li>");
			var $ul = $("<ul class='dropMenu displayNone' style=\"display: block;\">", {});
			for (i = 0; i < extraMenueArray.length; i++) {
				$ul.append(extraMenueArray[i]);
			}
			$('#mainMenu li.add').removeClass("displayNone");
			$('#mainMenu li.add').append($ul);
		}
		else {
			$('#mainMenu li.add').addClass("displayNone");
		}

		$('#mainMenu a').on('click keydown', function (e) {
			  $(this).focus();
			  menue_key_event(e);
			  if ($(e.target).closest('.add').length == 0 && ($('#openPlusMenu').next('ul').hasClass('displayNone')==false)) {
				  $('#openPlusMenu').next('ul').addClass('displayNone');
			  }
		});
	}
	if ($('.helpContainer').find('ul').length > 0) {
		$('.helpContainer').find('ul').remove();
	}
	
	// Adding placeholders for empty menus lists
	var $emptyMenus = $("ul.dropMenu:empty");
	
	$emptyMenus.each(function (index) {
		$(this).append("<li><a href=\"#\" class=\"merk_menu_item_\" id=\"merk_menu_item_\" onclick=\"global_click(0, 0)\">" + get_message_string(1241) + "</a></li>");
	});
	
};

MrkMenuFrame.prototype.erase = function (menu_id) {
	$('#merk_menu_item_' + menu_id).siblings('ul:not(".personalMenu")').removeClass("lastMenu");
	//if(lastMenuItemClicked == "M")
	//{
		$('#merk_menu_item_' + menu_id).siblings('ul:not(".personalMenu")').remove();
	//}
	$('.personalMenu').addClass("displayNone");
};

MrkMenuFrame.prototype.click = function (ex,clientX,clientY) {
	var i;
	for (i = 0; i < this.elements.length; i++) {
		if (this.elements[i].ex == ex) {

			if(clientX == null)
			{
				hide_home_page(this.elements[i].etype);
				hide_menu(this.elements[i].etype);

				var menuItem = $("#merk_menu_item_" + ex).parent();
				
				//if last item clicked is not a menu and we are clicking a main menu item display hidden menus 
				/*if(lastMenuItemClicked != "" && lastMenuItemClicked != "M" && lastMainMenuItemClicked == ex)
				{
					var activeMenuItem = $("#merk_menu_item_" + ex).parent();
					activeMenuItem.find("ul").each(function() {
						$(this).removeClass("displayNone");
					});
					activeMenuItem.find('.lastMenu').children('li').removeClass('active');
					activeMenuItem.find('.lastMenu').children('li:first-child').addClass('active');
				}
				else{*/
					menuClickNew(this.menuType, this.elements[i].fatexec, this.elements[i].ex, this.elements[i].etype, this.elements[i].ename, this.elements[i].type);
				//}

				//if last menu item clicked is a main menu item, save its id so we can return to open menus later
				if(menuItem.hasClass("menue_li")) {
					lastMainMenuItemClicked = ex;
				}
				lastMenuItemClicked = this.elements[i].type;
				if(lastMenuItemClicked != "M" && lastMenuItemClicked != "")
				{
					menuItem.siblings(".active").removeClass("active");
					menuItem.addClass("active");
				}
			}
			else
			{
				
				menuRightClick(this.menuType, this.elements[i].fatexec, this.elements[i].ex, this.elements[i].etype, this.elements[i].ename, this.elements[i].type,clientX,clientY)
			}
			return;
		}
	}
};

/* MrkMenu => main menu object */

/* constructor */
MrkMenu = function () {
	this.activeState = false;
	this.headFrame = null;
	this.currentFrame = null;

	this.clickedFrameId = 0;
};

MrkMenu.prototype.menuChangeMain = function (ex, xmlData, type) {
	this.xmlToMenuFrame(ex, xmlData, type);
};

MrkMenu.prototype.clearCallback = function (type, ex) {
	//alert('ClearCallback');
};

//// MENUE TYPES///////////////////
MrkMenu.prototype.menuChangeCallback = function (type, ex, xmlData, isPersonalMain = false) {
	if (type == 0 && !isPersonalMain || type == 1 && isPersonalMain) {
		 $('#menuHeader').removeClass('displayNone');
		 if(ex == 0 )
		 {
			GLOBAL_MENUE_XML = xmlData;
		 }
		this.menuChangeMain(ex, xmlData, type);
	}
	else if (type == 1 && !isPersonalMain) {
		this.menuChangePersonal(ex,xmlData);
	}
	else if (type == 2) {
		this.menuChangeRecent(ex,xmlData);
	}

	 else if (type == 4) {
		this.menuSavedQuery(ex,xmlData);
	}
	
	 else if (type == 5) {
		this.menuToolBar(ex,xmlData);
	}
	else if (type == 6) {
		create_homepage_menu(ex,xmlData);
	}
	else if (type == 8) {
		this.menuLastDocChange(ex,xmlData);
	}
};

MrkMenu.prototype.activeChangeCallback = function (active) {
	this.activeState = active == 0 ? false : true;
};

MrkMenu.prototype.menuChangePersonal = function (ex, xmlData) {
	if(ex == 0)
	{
		var $x = xmlData.replace('<?xml version="1.0" encoding="UTF-8"?>', '<?xml version="1.0" encoding="UTF-8"?><root>');
		$x += '</root>';

		xmlDoc = $.parseXML($x), $xml = $(xmlDoc);

		PERSONAL_ELEMENTS = create_element_array_from_xml(ex,xmlDoc);
		
		var $ul = $("<ul class='personalMenu dropMenu displayNone'>", {});
		if ( PERSONAL_ELEMENTS.length == 0 ) {
		    $ul.append("<li><a href=\"#\" class=\"merk_menu_item_\" id=\"merk_menu_item_\" onclick=\"global_click(0, 0)\">" + get_message_string(1241) + "</a></li>");
		    
		} else {
			for (i = 0; i < PERSONAL_ELEMENTS.length; i++) {
		    	var $li = $("<li>", {});
		    	var liClass = "class='merk_menu_item_" + PERSONAL_ELEMENTS[i].icontype;
		    	if (window.inline_manual_player)
		        	liClass += " " + PERSONAL_ELEMENTS[i].ename + "_" + PERSONAL_ELEMENTS[i].etype;
		    	liClass += "'";
				$li.append($("<a href=\"#\" " + liClass + "' id=\"personal_menue_item_" + PERSONAL_ELEMENTS[i].ex +  "\" onclick=\"personal_item_menue_click(1,"+PERSONAL_ELEMENTS[i].fatexec+ ","+PERSONAL_ELEMENTS[i].ex+ ",'" +PERSONAL_ELEMENTS[i].etype+ "','"  +PERSONAL_ELEMENTS[i].ename+ "','" +PERSONAL_ELEMENTS[i].type+ "', event)\">", {/*class: $cl*/ }).text(PERSONAL_ELEMENTS[i].title));
				$ul.append($li);
			}
			$ul.find('li').first().addClass('active');
		//currentMenueActive = $ul.find('li').first();
		//currentMenueActive.addClass('active');
		//$("#personal_menu").find('ul').remove();
		}
		$("#btnFavorite").find('ul').remove();
		$("#btnFavorite").append($ul);
	//	create_homepage_menu(PERSONAL_ELEMENTS);
		
		
	}
	else {
		if ($("#personal_menue_item_" + this.id).children().length > 1) {
			return;
		}
		
		if ($('#personal_menue_item_' + ex).closest('ul').hasClass('personalMenu')) {
			$('#personal_menue_item_' + ex).closest('.personalMenu').find('ul.dropMenu').remove();
		}
		else if($('#personal_menue_item_' + ex).closest('ul').hasClass('dropMenu'))
		{
			$('#personal_menue_item_' + ex).closest('.dropMenu').find('ul.dropMenu').remove();
		}

		var $x = xmlData.replace('<?xml version="1.0" encoding="UTF-8"?>', '<?xml version="1.0" encoding="UTF-8"?><root>');
		$x += '</root>';

		xmlDoc = $.parseXML($x), $xml = $(xmlDoc);
		var elements = create_element_array_from_xml(ex, xmlDoc);
	  
		$(".lastMenu").removeClass("lastMenu");
		var $ul = $("<ul class='dropMenu lastMenu' style=\"display: block;\">", {});
		for (i = 0; i < elements.length; i++) {
		    var $li = $("<li>", {});
		    var liClass = "class='merk_menu_item_" + elements[i].icontype;
		    if (window.inline_manual_player)
		        liClass += " " + elements[i].ename + "_" + elements[i].etype;
		    liClass += "'";
			$li.append($("<a href=\"#\" " + liClass + " 'data-type='" + elements[i].type + "'  id=\"personal_menue_item_" + elements[i].ex + "\" onclick=\"personal_item_menue_click(1," + elements[i].fatexec + "," + elements[i].ex + ",'" + elements[i].etype + "','" + elements[i].ename + "','" + elements[i].type + "', event)\">", {/*class: $cl*/ }).append(elements[i].title));
		   
			$ul.append($li);
		}
		if (elements.length > 0) {
			$("#personal_menue_item_" + ex).parent().find('ul').remove();
			$("#personal_menue_item_" + ex).parent().append($ul);
			$ul.find('li').first().addClass('active');
		}
	}
	
	$('#personal_menu').off();
	$('body .personalMenu a').off();
	setTimeout(function(){  
	var menuEvents = $._data( $('#personal_menu')[0], 'events' );
		if(menuEvents == null)
		{
			//$('#personal_menu').keydown(function (e) {
			//    menue_key_event(e);
			//});
			$('body .personalMenu a').on("click", function (e) {
				if (!$(e.target).closest('.dropMenu.lastMenu').prev().hasClass('merk_menu_item_M') || ($(e.target).parent().hasClass('personalMenu') && !$(e.target).hasClass('merk_menu_item_M'))) {
					$('.personalMenu .dropMenu').remove();
				}
			});
			$('#personal_menu').on('keydown', (function (e) {              
				menue_key_event(e);
			}));
		} else {
			$('#personal_menu').on('keydown', (function (e) {
				menue_key_event(e);
			}));
			$('body .personalMenu a').on("click", function (e) {
				if (!$(e.target).closest('.dropMenu.lastMenu').prev().hasClass('merk_menu_item_M') || ($(e.target).parent().hasClass('personalMenu') && !$(e.target).hasClass('merk_menu_item_M'))) {
					$('.personalMenu .dropMenu').remove();
				}
			});
		}

	}, 0);  
};
MrkMenu.prototype.menuToolBar = function (ex, xmlData) {
	if(ex == 0)
	{
		var $x = xmlData.replace('<?xml version="1.0" encoding="UTF-8"?>', '<?xml version="1.0" encoding="UTF-8"?><root>');
		$x += '</root>';

		xmlDoc = $.parseXML($x), $xml = $(xmlDoc);

		TOOL_BAR_ELEMENTS = create_element_array_from_xml(ex,xmlDoc);
		
		var $ul = $("<ul class='toolBar dropDown'>", {});
		for (i = 0; i < TOOL_BAR_ELEMENTS.length; i++) {
			var liIconClass = TOOL_BAR_ELEMENTS[i].icon
			var $li =  $("<li class="+liIconClass+">", {});
			$li.append($("<a href=\"#\" data-type='" + TOOL_BAR_ELEMENTS[i].type + "' data-enabled='" + TOOL_BAR_ELEMENTS[i].enabled + "' id=\"toolbar_menue_item_" + TOOL_BAR_ELEMENTS[i].ex + "\" title=\"" + TOOL_BAR_ELEMENTS[i].help + "\" onclick=\"toolbar_item_menue_click(event, 5," + TOOL_BAR_ELEMENTS[i].fatexec + "," + TOOL_BAR_ELEMENTS[i].ex + ",'" + TOOL_BAR_ELEMENTS[i].etype + "','" + TOOL_BAR_ELEMENTS[i].ename + "','" + TOOL_BAR_ELEMENTS[i].type + "','" + TOOL_BAR_ELEMENTS[i].enabled + "')\">", {}).append(TOOL_BAR_ELEMENTS[i].title).append("<b class=\"shortcuts\">" + TOOL_BAR_ELEMENTS[i].shortcuts + "</b>"));
			$ul.append($li);
		}
		if ($("#hamburgerMenu").find("ul.toolBar").length > 0) {
			hamburgerExist = true;
		} else {
			hamburgerExist = false;
		}

		$("#hamburgerMenu").append($ul);
	}
	else{
		var $x = xmlData.replace('<?xml version="1.0" encoding="UTF-8"?>', '<?xml version="1.0" encoding="UTF-8"?><root>');
		$x += '</root>';
		xmlDoc = $.parseXML($x), $xml = $(xmlDoc);
		var elements = create_element_array_from_xml(ex, xmlDoc);
		var $ul = $("<ul class='dropMenu lastMenu' style=\"display: block;\">", {});
		for (i = 0; i < elements.length; i++) {
			var liIconClass = elements[i].icon
			var $li = $("<li class="+liIconClass+">", {});
			$li.append($("<a href=\"#\" data-type='" + elements[i].type + (elements[i].checked == "1" ? "' class=\"select-v\"' " : '') + "' data-enabled='" + elements[i].enabled + "' id=\"toolbar_menue_item_" + elements[i].ex + "\" title=\"" + elements[i].help + "\" onclick=\"toolbar_item_menue_click(event, 5," + elements[i].fatexec + "," + elements[i].ex + ",'" + elements[i].etype + "','" + elements[i].ename + "','" + elements[i].type + "','" + elements[i].enabled + "')\">", { /*class: $cl*/ }).append(elements[i].title).append("<b class=\"shortcuts\">" + elements[i].shortcuts + "</b>"));
			$ul.append($li);
		}
		if ($("#hamburgerMenu").find('li').length == 0) {
				if ($('.helpContainer').find('ul').length > 0) {
					//$('.helpContainer').find('ul').remove();
					$ul.removeClass('lastMenu').addClass('lastMenuHelp');
				} else {
					$ul.addClass('dropMenuHelp');
				}
			$('.helpContainer').append($ul);
		} else {
			$(".lastMenu").removeClass("lastMenu");
			$("#toolbar_menue_item_" + ex).parent().append($ul);
			$("#toolbar_menue_item_" + ex).parent().find('ul li:first-child').addClass('active');
			$("#toolbar_menue_item_" + ex).parent().find('ul li:first-child a').focus();
		}
		
		//check if menus height overflow window boundaries, if so, we move them inside	
	}
};

function escapeUntrustedData(data) {
	return data.replace(/&/g, "&amp;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;")
		.replace(/"/g, "&quot;")
		.replace(/'/g, "&apos;")
		.replace(/\//g, "&#47;");
}

MrkMenu.prototype.menuLastDocChange = function (ex, xmlData) {
    var $x = xmlData.replace('<?xml version="1.0" encoding="UTF-8"?>', '<?xml version="1.0" encoding="UTF-8"?><root>');
    $x += '</root>';

    xmlDoc = $.parseXML($x), $xml = $(xmlDoc);


    LAST_UPDATES = create_element_array_from_xml(ex, xmlDoc);

    var $lastUpdContainer = $("<div id='lastUpdatesContainer' class='lastUpdatesContainer'>", {});
    var $ul = $("<ul class='sideMenu lastUpdates'>", {});
    for (i = 0; i < LAST_UPDATES.length; i++) {
        var $li = $("<li><span class='lastUpdateBullet'></span>", {});


		$li.append($("<a class='btnDropDown' href=\"#\" \" onclick=\"lastUpdates_item_menue_click('"+LAST_UPDATES[i].ename + "','" + LAST_UPDATES[i].docNo + "','" + LAST_UPDATES[i].etype + "')\">", {/*class: $cl*/ }).append(LAST_UPDATES[i].title + " " + escapeUntrustedData(LAST_UPDATES[i].docNo)  + " " + escapeUntrustedData(LAST_UPDATES[i].details)));
        $ul.append($li);
    }

    // $("#sideMenuWrapper ul.lastUpdates").remove();	
    // $("#sideMenuWrapper a.lastUpdates").text(get_message_string(1270)).after($ul);   

    $(".lastUpdatesContainer").remove();
    $lastUpdContainer.append($ul);
    $("#sideMenuWrapper a.lastUpdates").text(get_message_string(1270)).after($lastUpdContainer);


    if ($('.recentActivities').next().hasClass('hidden-list')) {
        $('.lastUpdatesContainer').css('height', '703px');
    }

    // Adding Custom Scrollbar to Sidebar
    $(".lastUpdatesContainer").mCustomScrollbar();

    resize_homepage();
    // if($(".lastUpdates").length > 0)
    // {

    // }
    // else
    // {
    // var $lastUpdatesHeader = $('<a class="sidebar-header lastUpdates">' + get_message_string(1270) + '</a>');
    // $("#sideMenuWrapper").append($lastUpdatesHeader);
    // }

    //$("#sideMenuWrapper ul.lastUpdates").empty();	
    

    //sidebarHeaderClick();
};

//var sidebarHeaderClick = function() {
function sidebarHeaderClick(e) {
	$(e).toggleClass('closed');
	$(e).next().slideToggle('fast');
	$(e).next().toggleClass('hidden-list');

	//console.log($(e));

	if ($(e).hasClass('recentActivities')) {
		if (!$(e).next().hasClass('hidden-list')) {
			$('.lastUpdatesContainer').css('height', '413px');
		} else {
			$('.lastUpdatesContainer').css('height', '703px');
		}
    }
    resize_homepage();
};


MrkMenu.prototype.menuChangeRecent = function (ex,xmlData) { 
	var $x = xmlData.replace('<?xml version="1.0" encoding="UTF-8"?>', '<?xml version="1.0" encoding="UTF-8"?><root>');
	$x += '</root>';

	xmlDoc = $.parseXML($x), $xml = $(xmlDoc);

	RECENT_ELEMENTS = create_element_array_from_xml(ex,xmlDoc);
	
	//var $lastUpdatesHeader = $('<a class="sidebar-header">' + get_message_string(1270) + '</a>');
	// var $followUpTopicsHeader = $('<a class="sidebar-header">' + get_message_string(1271) + '</a>');
	// var $eventsHeader = $('<a class="sidebar-header">' + get_message_string(1272) + '</a>');

	var $ul = $("<ul class='sideMenu recentActivities'>", {});
	for (i = 0; i < RECENT_ELEMENTS.length; i++) {
		var $li = $("<li>", {});

		$li.append($("<a class='btnDropDown recentItem merk_menu_item_"+ RECENT_ELEMENTS[i].icontype+"' href=\"#\" id=\"merk_menu_item_" + RECENT_ELEMENTS[i].ex +  "\" onclick=\"personal_item_menue_click(2, '"+RECENT_ELEMENTS[i].fatexec+ "','"+RECENT_ELEMENTS[i].ex+ "','" +RECENT_ELEMENTS[i].etype+ "','"  +RECENT_ELEMENTS[i].ename+ "','" +RECENT_ELEMENTS[i].type+ "', event)\">", {/*class: $cl*/ }).append(RECENT_ELEMENTS[i].title));
		$ul.append($li);
	}

	$("#sideMenuWrapper ul.recentActivities").remove();
	$("#sideMenuWrapper a.recentActivities").text(get_message_string(171) ).after($ul);   
	
	// if($(".recentActivities").length > 0)
	// {
		
	// }
	// else
	// {
		// var $lastOperationsHeader = $('<a class="sidebar-header first-header recentActivities">' + get_message_string(171) + '</a>');
		// $("#sideMenuWrapper").append($lastOperationsHeader);
	// }
	
	// $("#sideMenuWrapper .recentActivities").remove();
	// $("#sideMenuWrapper").append($lastOperationsHeader);
	// $("#sideMenuWrapper").append($ul);   
	// $("#sideMenuWrapper").append($lastUpdatesHeader);
	// $("#sideMenuWrapper").append($followUpTopicsHeader);
	// $("#sideMenuWrapper").append($eventsHeader);

	//sidebarHeaderClick();
};

MrkMenu.prototype.menuSavedQuery = function (ex,xmlData) { 
	
	if(!xmlData) //recon form
	{
		if(!$(".btnAdvanced").hasClass("displayNone"))
		{
			$(".advancedQueryBtn").addClass("displayNone");
			$(".btnAdvanced").addClass("displayNone");
		}
		return;	
	}
	
	if($(".btnAdvanced").hasClass("displayNone"))
		$(".btnAdvanced").removeClass("displayNone");
	
	$(".advancedQueryList").remove();
	var $x = xmlData.replace('<?xml version="1.0" encoding="UTF-8"?>', '<?xml version="1.0" encoding="UTF-8"?><root>');
	$x += '</root>';

	xmlDoc = $.parseXML($x), $xml = $(xmlDoc);

	QUERY_ELEMENTS = create_element_array_from_xml(ex,xmlDoc);
	if(QUERY_ELEMENTS.length > 0) {
		var $ul = $("<ul class='advancedQueryList displayNone'>", {});
		for (i = 0; i < QUERY_ELEMENTS.length; i++) {
			var $li = $("<li>", {});
			$li.append($("<a class='btnDropDown merk_menu_item_"+ QUERY_ELEMENTS[i].etype+"' href=\"#\" id=\"merk_menu_item_" + QUERY_ELEMENTS[i].ex +  "\" onclick=\"select_query_callback('"+QUERY_ELEMENTS[i].ex+ "')\">", {/*class: $cl*/ }).append("<span class='itemShortcut'>" + QUERY_ELEMENTS[i].ename +"</span>").append("<span class='itemTitle'>" + QUERY_ELEMENTS[i].title +"</span>"));
			$ul.append($li);
		}
		$(".advancedQueryBtn").removeClass("displayNone");
		$("#advanced_query").parent().append($ul); 
	} else {
		$(".advancedQueryBtn").addClass("displayNone");
	}

	$('.advancedQueryBtn').on('keydown', (function (e) {
		menue_key_event(e);
	}));
};

MrkMenu.prototype.xmlToMenuFrame = function (ex, xmlData, type) {
	if (this.currentFrame != null && this.currentFrame.id == ex) {
		this.currentFrame.reload(ex,xmlData);
	}
	else {
		/* go to clicked */
		this.gotoClicked(ex, xmlData, type);
	}
};

MrkMenu.prototype.getFrame = function (frameId) {
	var frame = this.headFrame;
	while (frame != null) {
		if (frame.id == frameId)
			return frame;
		frame = frame.nextFrame;
	}
	return null;
};

MrkMenu.prototype.gotoClicked = function (ex, xmlData, type) {
	this.go(ex, xmlData, type);
};

MrkMenu.prototype.go = function (ex, xmlData, type) {
	/* in case of change company event */
	if (ex == 0)
		this.clickedFrameId = 0;
	

	var frame = this.currentFrame;
	var clickedFrame = this.getFrame(this.clickedFrameId);
	var clickedFrameId = 0;

	if (clickedFrame != null)
		clickedFrameId = clickedFrame.id;

	while (frame != null && (frame.id != clickedFrameId || ex == 0)) {
		var framePrev = frame;

		frame.erase(frame.id);
		frame = frame.parentFrame;

		delete framePrev;

		if (frame != null)
			frame.next = null;

		this.currentFrame = frame;
	}


	if (this.currentFrame == null) {
		this.headFrame = this.currentFrame = new MrkMenuFrame(0, null, xmlData, type);
	}
	else {
		this.currentFrame.nextFrame = new MrkMenuFrame(ex, this.currentFrame, xmlData, type);
		this.currentFrame = this.currentFrame.nextFrame;
	}
};

MrkMenu.prototype.click = function (ex, menuFrameId,clientX,clientY) {
	if (!this.activeState)
		return;

	if($('#merk_menu_item_' + ex).hasClass("merk_menu") && ex == lastMainMenuItemClicked)
	{
		if($('#merk_menu_item_' + ex).parent().find("ul").length > 0)
		{
			$('ul:not(.add .dropMenu)', '#mainMenu').removeClass("displayNone");
			return;
		}
	}
	
	var frame = this.getFrame(menuFrameId);
	if (frame != null) {
		this.clickedFrameId = menuFrameId;
		frame.click(ex,clientX,clientY);
	}
};



